
// src/helpers/number-regexp.js
export default function(value) {
  if (typeof value !== 'number') return value
  // 整数部分と小数部分に分割
  var numData = value.toString().split('.');
  // 整数部分を3桁カンマ区切りへ
  numData[0] = Number(numData[0]).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  // 小数部分と結合して返却
  return numData.join('.');
};


// WEBPACK FOOTER //
// ./src/helpers/number-regexp.js